import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { bool, string } from 'prop-types';

const SoundItem = forwardRef(({ url, autoplay }, ref) => {
  const sound = useRef({});

  useEffect(() => {
    sound.current = new Audio(url);
    sound.current.autoplay = autoplay;
    sound.current.preload = 'auto';
  }, [autoplay, url]);

  useImperativeHandle(ref, () => ({
    async play() {
      const { current: audio } = sound;
      if (audio) {
        try {
          if (audio.currentTime) {
            audio.load();
            await audio.play();
          } else if (audio.readyState === 4 || audio.readyState === 3) {
            await audio.play();
          }
          // eslint-disable-next-line no-empty
        } catch {}
      }
    },
  }));
  return null;
});

SoundItem.propTypes = {
  url: string,
  autoplay: bool,
};
SoundItem.displayName = 'SoundItem';
export default SoundItem;
